import { createFileRoute, redirect } from '@tanstack/react-router';

import { ACCOUNT_SETTINGS_PATH } from '@/features/identity';

/** Settings opens on the Account page (spec 239), the first in the rail. */
export const Route = createFileRoute('/settings/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's redirect is thrown by design
    throw redirect({ to: ACCOUNT_SETTINGS_PATH, replace: true });
  },
});
